import { takeEvery, select, put } from 'redux-saga/effects'
// @ts-ignore
import { difference } from 'lodash'

import {
  updateOrganizationProtrackLevelTeams,
  updateOrganizationProtrackLevelTeamsSuccessForMicroactions,
} from '../actions'
import { getPendingObject, getOrganizationTeamsById } from '../selectors'
import { organizationId as getOrganizationId } from 'store/entities/router/selectors'

export function* handleUpdateOrganizationProtrackLevelTeamsSuccess() {
  const pendingObject = yield select(getPendingObject)
  const organizationId = yield select(getOrganizationId)
  const organizationTeamsList = yield select(getOrganizationTeamsById(organizationId))
  const newTeams = difference(pendingObject.teams.toJS, organizationTeamsList.toJS())
  const { teams, proTrackLevelId } = pendingObject
  const payloadNew = {
    proTrackLevelId,
    teams,
    newTeams,
    organizationId,
    organizationTeams: organizationTeamsList,
  }
  yield put(updateOrganizationProtrackLevelTeamsSuccessForMicroactions(payloadNew as any))
}

export default function* takeEveryUpdateOrganizationProtrackLevelTeams() {
  yield takeEvery(
    updateOrganizationProtrackLevelTeams.success.toString(),
    handleUpdateOrganizationProtrackLevelTeamsSuccess
  )
}
